import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import DataSourceResource from "../../../DataSource.resource.js";
import { convertToPostParams } from "../components/CreateWizard/DataSourceCreateFormSettings.js";
const defaultReducerState = { res: getDefaultAsyncWrapperObj() };
const prefix = "updateDataSource";
const CLEAR_DATA_SOURCE_STATE = `${prefix}/CLEAR_STATE`;
const clearUpdateDataSourceState = () => ({
  type: CLEAR_DATA_SOURCE_STATE
});
const updateDataSourceArgs = {
  actionPrefix: `${prefix}/LOAD`,
  reduxKeyNested: () => ["res"],
  loadResource: (inputPayload) => {
    let dataSourcePost = convertToPostParams(inputPayload);
    return DataSourceResource.putDataSource(dataSourcePost);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const updateDataSourceEpicReducer = loadResourcesUtils(updateDataSourceArgs);
const updateDataSourceReducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case CLEAR_DATA_SOURCE_STATE:
      return defaultReducerState;
    default:
      return updateDataSourceEpicReducer.reduxChange(state, action);
  }
};
export {
  clearUpdateDataSourceState,
  updateDataSourceReducer as default,
  defaultReducerState,
  updateDataSourceEpicReducer,
  updateDataSourceReducer
};
//# sourceMappingURL=DataSourceUpdate.ducks.js.map
